

export class Asset {
  id: string;
  file: File | null;
  name: string;
  storage_uri: string;
  constructor(data?: Partial<Asset>) {
    this.id = data?.id || "";
    this.file = null;
    this.name = data?.name || "";
    this.storage_uri = data?.storage_uri || "";
  }
}
